import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

/**
 * index模块
 */
const app = r => require.ensure([], () => r(require('../App.vue')), 'app')

//import Home from '../view/Home.vue'
const Home = r => require.ensure([], () => r(require('../view/Home.vue')), 'Home')

//产品
const Product = r => require.ensure([], () => r(require('../view/product/product.vue')), 'Product')
const ProductChild = r => require.ensure([], () => r(require('../view/product/productChild.vue')), 'ProductChild')

//案例
const Case = r => require.ensure([], () => r(require('../view/case/case.vue')), 'Case')
const CaseChild = r => require.ensure([], () => r(require('../view/case/caseChild.vue')), 'CaseChild')
const CaseDetail = r => require.ensure([], () => r(require('../view/case/caseChild.vue')), 'CaseDetail')

//新闻
const News = r => require.ensure([], () => r(require('../view/news/news.vue')), 'News')
const NewsChild = r => require.ensure([], () => r(require('../view/news/newsChild.vue')), 'NewsChild')
const NewsDetail = r => require.ensure([], () => r(require('../view/news/newsChild.vue')), 'NewsDetail')

//展馆
const Pavilion = r => require.ensure([], () => r(require('../view/pavilion/pavilion.vue')), 'Pavilion')
const PavilionChild = r => require.ensure([], () => r(require('../view/pavilion/PavilionChild.vue')), 'PavilionChild')
const PavilionDetail = r => require.ensure([], () => r(require('../view/pavilion/PavilionChild.vue')), 'PavilionDetail')

const Aboutus = r => require.ensure([], () => r(require('../view/aboutus/aboutus.vue')), 'Aboutus')

// const Drama = r => require.ensure([], () => r(require('../view/drama/drama.vue')), 'Drama')


export default new Router({
  mode:'history',
  routes: [{
      // path: '/',
      // redirect: '/home'
    path: '/',
    name: '/',
    component: Home,
    children: [{
      path: '/newsDetail',
      name: 'newsDetail',
      component: NewsDetail,
    }, {
      path: '/caseDetail',
      name: 'caseDetail',
      component: CaseDetail,
    }]
    },
    //首页
    {
      path: '/',
      name: 'home',
      component: Home,
      children: [{
        path: '/newsDetail',
        name: 'newsDetail',
        component: NewsDetail,
      }, {
        path: '/caseDetail',
        name: 'caseDetail',
        component: CaseDetail,
      }]
    },
    {
      path: '/product',
      name: 'product',
      component: Product,
      meta: {
        keepAlive: true
      },
      children: [{
        path: '/productChild',
        name: 'productChild',
        component: ProductChild,
      }, ]
    },

    {
      path: '/case',
      name: 'case',
      component: Case,
      meta: {
        keepAlive: true
      },
      children: [{
        path: '/caseChild',
        name: 'caseChild',
        component: CaseChild,
      }]
    },

    {
      path: '/news',
      name: 'news',
      component: News,
      meta: {
        keepAlive: true,
      },
      children: [{
        path: '/newsChild',
        name: 'newsChild',
        component: NewsChild,
      }]
    },
    {
      path: '/pavilion',
      name: 'pavilion',
      component: Pavilion,
      meta: {
        keepAlive: true,
      },
      children: [{
        path: '/pavilionChild',
        name: 'pavilionChild',
        component: PavilionChild,
      }]
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: Aboutus,
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js